import styled from 'styled-components'
import { device } from '../Breakpoints'

const Container = styled.div`
  background: #ffffff;
  margin-bottom: 15px;
  width: 100%;
  @media ${device.mobileL} {
    margin-bottom: 60px;
  }

  h3 {
    color: #148581;
    display: inline-block;
    padding: 1em;
    font-weight: 300;
    margin: 0;
    position: relative;
    font-size: 1.3em;
    ::before {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      bottom: -10px;
      left: 45%;
      position: absolute;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #ffffff;
    }
  }
  .servicos {
    background: linear-gradient(to bottom, #8ec7b5, #478e8b);
    display: flex;
    align-items: center;
    @media ${device.mobileL} {
      flex-wrap: wrap;
      padding: 20px 40px 6px;
    }
  }
  .description-text {
    padding: 60px 20px 40px 20px;
    color: #ffffff;
    margin: 0;
    font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
    width: 100%;
    font-size: 0.9em;
    min-width: 240px;
    max-width: 240px;
    font-weight: 700;
    @media ${device.mobileL} {
      width: auto;
      min-width: 0;
      max-width: 100%;
      padding-left: 0;
    }
  }
  .sliderContainer {
    flex-grow: 4;
    min-width: 1px;
    margin-bottom: -5px;
    background-color: #f9f9f7;
  }
  .slick-slide {
    min-height: 100%;
    height: 100%;
    img {
      width: 100%;
    }
    a {
      text-decoration: none;
      text-align: center;
      h4 {
        font-size: 0.9em;
        color: #148581;
      }
      p {
        font-size: 0.7em;
        color: #ababa9;
        padding: 1.2em 2em;
      }
    }
  }

  .slick-prev {
    left: 30px !important;
    z-index: 9999;
    width: 50px;
  }

  .slick-dots {
    bottom: -42px;
  }
  .arrow {
    top: -50px !important;
    position: absolute;
    background: #f0f0f0;
    display: block;
    border-radius: 100%;
    z-index: 1;
    color: #7b7b7b;
    text-align: center;
    cursor: pointer;
    :hover {
      background: #c3c3c3;
    }
    @media ${device.mobileL} {
      top: inherit !important;
      bottom: -50px !important;
    }
  }
  .prev {
    right: 5em !important;
    width: 30px;
    padding: 4px 6px 0px 3px;
    @media ${device.mobileL} {
      right: inherit !important;
      left: 12% !important;
    }
  }
  .next {
    right: 2em !important;
    width: 27px;
    padding: 5px 6px 0px;
    @media ${device.mobileL} {
      right: 12% !important;
      left: inherit !important;
    }
  }
`

export default Container
